(function () {
  'use strict';

 const player  = document.getElementById('vsPlayer');
if (!player) return;

// Teleport player to <body> to escape any positioned ancestors in Dawn's layout
document.body.appendChild(player);

const video    = document.getElementById('vsVideo');
  const closeBtn = document.getElementById('vsClose');
  const prevBtn  = document.getElementById('vsPrev');
  const nextBtn  = document.getElementById('vsNext');
  const infoEl   = document.getElementById('vsInfo');
  const progBar  = document.getElementById('vsProgress');

  let slides  = [];
  let current = 0;
  let timer   = null;
  let pct     = 0;
  const FALLBACK_DURATION = 8000;

  document.querySelectorAll('.vs-item').forEach((el, i) => {
    slides.push({
      title:  el.dataset.title  || '',
      desc:   el.dataset.desc   || '',
      src:    el.dataset.src    || '',
      cta:    el.dataset.cta    || '',
      ctaUrl: el.dataset.ctaUrl || '#',
      el
    });
    el.addEventListener('click', () => openAt(i));
    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openAt(i); }
    });
  });

  function buildProgress() {
    progBar.innerHTML = slides.map((_, i) =>
      `<div class="vs-seg"><div class="vs-seg-fill${i < current ? ' done' : ''}" id="vsp${i}"></div></div>`
    ).join('');
  }

  function startTimer() {
    clearInterval(timer);
    pct = 0;
    const fill = document.getElementById(`vsp${current}`);
    if (!fill) return;
    const dur = (video.duration && isFinite(video.duration))
      ? video.duration * 1000
      : FALLBACK_DURATION;
    const tick = 80;
    timer = setInterval(() => {
      pct = Math.min(pct + (tick / dur) * 100, 100);
      fill.style.width = pct + '%';
      if (pct >= 100) { clearInterval(timer); goNext(); }
    }, tick);
  }

  function render() {
    const s = slides[current];
    buildProgress();
    infoEl.innerHTML =
  `<p class="vs-info__title">${s.title}</p>` +
  (s.desc ? `<p class="vs-info__desc">${s.desc}</p>` : '') +
  `<button class="vs-cta" id="vsCtaBtn">Add to cart</button>`;

document.getElementById('vsCtaBtn')?.addEventListener('click', () => {
  closePlayer();
  const addToCart = document.querySelector('button[name="add"]') 
    || document.querySelector('.product-form__submit');
  if (addToCart) {
    addToCart.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => addToCart.click(), 400);
  }
});

    slides.forEach((_, i) => {
      document.getElementById(`vs-ring-${i}`)?.classList.toggle('watched', i < current);
    });

    video.src = s.src;
    video.load();
    const p = video.play();
    if (p !== undefined) p.catch(() => {});

    if (video.readyState >= 1 && isFinite(video.duration)) {
      startTimer();
    } else {
      video.addEventListener('loadedmetadata', startTimer, { once: true });
      setTimeout(() => { if (pct === 0) startTimer(); }, 1500);
    }
  }

  function openAt(idx) {
    current = idx;
    player.classList.add('open');
    player.setAttribute('aria-hidden', 'false');
    render();
  }

function goNext() {
  clearInterval(timer);
  if (current < slides.length - 1) {
    current++;
    render();
  } else {
    showEndScreen();
  }
}

function showEndScreen() {
  video.pause();
  document.getElementById('vsEndScreen')?.classList.add('visible');
}

function hideEndScreen() {
  document.getElementById('vsEndScreen')?.classList.remove('visible');
}

  function goPrev() {
    clearInterval(timer);
    if (current > 0) { current--; render(); }
  }

function closePlayer() {
  clearInterval(timer);
  video.pause();
  video.src = '';
  hideEndScreen();
  player.classList.remove('open');
  player.setAttribute('aria-hidden', 'true');
}

  closeBtn.addEventListener('click', closePlayer);
  nextBtn.addEventListener('click', goNext);
  prevBtn.addEventListener('click', goPrev);

  document.addEventListener('keydown', e => {
    if (!player.classList.contains('open')) return;
    if (e.key === 'Escape')     closePlayer();
    if (e.key === 'ArrowRight') goNext();
    if (e.key === 'ArrowLeft')  goPrev();
  });

  let touchX = 0;
  player.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  player.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 44) dx < 0 ? goNext() : goPrev();
  });
  document.getElementById('vsRestartBtn')?.addEventListener('click', () => {
  hideEndScreen();
  current = 0;
  // Reset all rings to unwatched
  slides.forEach((_, i) => {
    document.getElementById(`vs-ring-${i}`)?.classList.remove('watched');
  });
  render();
});

document.getElementById('vsEndCloseBtn')?.addEventListener('click', () => {
  hideEndScreen();
  closePlayer();
});
})();